import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { Button, Icon } from '@uturn/ui-kit';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchReady } from '../search-ready-context';
import { GlobalSearch } from './global-search';

export const Search = () => {
	const { t } = useTranslation();
	const [searchOpen, setSearchOpen] = useState(false);
	const isSearchReady = useSearchReady();

	return (
		<>
			<Button
				variant="outline"
				className="justify-start bg-transparent text-sm"
				onClick={() => setSearchOpen(!searchOpen)}
				disabled={!isSearchReady}
			>
				<span className="hidden lg:block">
					{t('header.search.trigger-button', 'Search shipments')}
				</span>
				<Icon className="-mx-1 block lg:hidden" icon={faMagnifyingGlass} />
			</Button>

			{isSearchReady && (
				<Suspense>
					<GlobalSearch
						openSearch={searchOpen}
						handleCloseSearch={() => setSearchOpen(!searchOpen)}
					/>
				</Suspense>
			)}
		</>
	);
};
